import { Avatar, AvatarProps, Skeleton } from '@mui/material';
import { memo, useEffect, useState } from 'react';

const VyAvatar = (props: AvatarProps) => {
  const [showSkeleton, setShowSkeleton] = useState(false);

  useEffect(() => setShowSkeleton(!!props.src), [props.src]);

  return (
    <div className="relative">
      <Avatar {...props} onLoad={() => setShowSkeleton(false)} />
      {showSkeleton && (
        <Skeleton variant="circular" className="absolute top-0 left-0 z-10 bg-slate-400" style={{ width: props.style?.width, height: props.style?.height }} />
      )}
    </div>
  );
};
export default memo(VyAvatar, (prevProps, nextProps) => prevProps.src === nextProps.src);
